/**
 * creative ドメイン共通スキーマ
 *
 * 全 canonical model が共有するタイムスタンプ・判定レベル表現。
 * このモジュールは外部 I/O を持たず、永続化層 (Firestore 等) には依存しない。
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business airCloset Design System ドメインの全モデルで共有するタイムスタンプ・判定レベルスキーマ。永続化層非依存の純粋な値表現。
 * @graph-connects none
 */
import { z } from 'zod';
/**
 * ISO8601 形式の日時文字列スキーマ。
 * @graph-connects none
 */
export const IsoDateTimeSchema = z.iso.datetime();
/**
 * createdAt / updatedAt / updatedBy の監査タイムスタンプスキーマ。
 *
 * creative の全永続化エンティティは「いつ・誰が最後に更新したか」を持ち、
 * 変更前後スナップショットは別途 `creative_audit_logs` に追記される。
 * @graph-connects none
 */
export const AuditedTimestampsSchema = z.object({
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
    updatedBy: z.string().min(1),
});
/**
 * チェック項目・ルールの逸脱時判定レベルスキーマ。
 *
 * `ng` = 修正必須（ブランドアイデンティティ・品質要素の逸脱）、
 * `caution` = 要確認（表現要素の逸脱。意図的ならデザイナー承認で解除）。
 * @graph-connects none
 */
export const DeviationLevelSchema = z.enum(['ng', 'caution']);
/**
 * レビュー出力の判定 3 段階スキーマ（逸脱レベル + `ok`）。
 * @graph-connects none
 */
export const JudgmentLevelSchema = z.enum(['ng', 'caution', 'ok']);
//# sourceMappingURL=common.js.map